import NumberUtils from 'frontools/utils/NumberUtils';
import { autobind } from 'frontools/decorators/Autobind';
import ScrollUtils from 'frontools/utils/ScrollUtils';
import VanillaUtils from 'frontools/utils/VanillaUtils';
import Context from 'frontools/core/Context';

declare var quotes;

export class Quotes {

    private _elMain             : HTMLElement;
    private _elButton           : HTMLButtonElement;
    private _elOutput           : HTMLElement;
    private _elCreatorOutput    : HTMLElement;
    private _elCreatorWrapper   : HTMLElement;
    private _quotes             : Array<string>;

    private _activeIndex        : number;
    private _clientX        : number;
    private _clientY        : number;

    private isAnimating     : boolean = false;

    private _elFlashCircle      : HTMLSpanElement;

    constructor(private _elWrapper: HTMLElement) {
        this._quotes = Context.getInstance().getValue('shootQuotes');

        this._elButton = this._elWrapper.querySelector('[data-quotes-button]') as HTMLButtonElement;
        this._elWrapper.addEventListener('click', this._changeQuote);
        this._elOutput = this._elWrapper.querySelector('[data-quotes-output]') as HTMLElement;
        this._activeIndex = parseInt(this._elOutput.getAttribute('data-quotes-index'));
        this._elCreatorOutput = this._elWrapper.querySelector('[data-quotes-creator-output]') as HTMLElement;
        this._elCreatorWrapper = this._elWrapper.querySelector('[data-quotes-creator-wrapper]') as HTMLElement;

        this._elMain = document.querySelector('main') as HTMLElement;

        let stopPropagationLinks = this._elWrapper.querySelectorAll('[data-stop-propagation]') as NodeListOf<HTMLElement>;
        for (let i = 0; i < stopPropagationLinks.length; i++) {
            stopPropagationLinks[i].addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        this.fixMainMargin(false);
        this._createFlashCircle();
    } 

    private _createFlashCircle() {
        this._elFlashCircle = document.createElement('SPAN');
        this._elFlashCircle.style.position = 'fixed';
        this._elFlashCircle.style.background = 'radial-gradient(ellipse at center, rgba(255,255,255, 0.4) 0%, transparent 80%)';
        this._elFlashCircle.style.borderRadius = '100%';
        this._elFlashCircle.style.left = 0+"px";
        this._elFlashCircle.style.top = 0+"px";
        // this._elFlashCircle.style.zIndex = 10;
        this._elWrapper.appendChild(this._elFlashCircle);
    }

    @autobind
    private _changeQuote(e) {
        // this._clientX = e.clientX;
        // this._clientY = e.clientY;

        // TweenMax.set(this._elFlashCircle,{
        //     x: this._clientX, 
        //     width: 0,
        //     height: 0,
        //     y: this._clientY, 
        //     opacity: 1,
        //     zIndex: '10'
        // });

        // var width = this._elWrapper.offsetWidth * 3;
        // TweenMax.to(this._elFlashCircle, 0.15, {
        //     opacity: 1,
        //     width: width, 
        //     height: width, 
        //     x:  e.clientX-width/2, 
        //     y:  e.clientY-width/2,
        //     ease: Back.easeOut,
        //     onComplete: this._fillText
        // });

        this._fillText();
    }

    @autobind
    private _fillText() {
        if (this.isAnimating) return;

        this.isAnimating = true;

        let newIndex = NumberUtils.random(0, this._quotes.length-1, true);
        while (this._activeIndex == newIndex) {
            newIndex = NumberUtils.random(0, this._quotes.length-1, true);
        }
        this._activeIndex = newIndex;
        let newText = (this._quotes[newIndex] as any).text;

        if (this._elCreatorWrapper) {
            TweenMax.to(this._elCreatorWrapper, 0.3,{opacity: 0, ease: Expo.easeOut});
        }

        TweenMax.to(this._elOutput, 0.3, {opacity: 0, ease: Expo.easeOut,
            onComplete: () => {
                TweenMax.set(this._elOutput, {opacity: 0});
                this._elOutput.innerHTML = newText;
                TweenMax.to(this._elOutput, 0.3, {opacity: 1, ease: Expo.easeOut,
                    onComplete: () => {
                        if (this._elCreatorOutput) {
                            this._elCreatorOutput.innerHTML = (this._quotes[newIndex] as any).creatorName;
                            (this._elCreatorOutput as any).href = (this._quotes[newIndex] as any).creatorUrl;
                            if (this._elCreatorWrapper) {
                                TweenMax.to(this._elCreatorWrapper, 0.3, {opacity: 1, ease: Expo.easeOut, 
                                    onComplete: () => {
                                        this.isAnimating = false;
                                    }
                                });
                            }
                        } else {
                            this.isAnimating = false;
                        }
                    }
                });
            }
        });


        
    }

    @autobind
    private _adjustFooterProps() {
        this._elFlashCircle.style.zIndex = '-1';
        this.fixMainMargin(true);
    }  

    public fixMainMargin(scroll:boolean) {
        TweenMax.to(this._elWrapper.parentNode, 0.05, {
            height: this._elWrapper.offsetHeight+"px", 
            ease: Linear.easeNone,
            onComplete: scroll ? this._scrollToBottom : undefined
        })
    }

    @autobind
    private _scrollToBottom() {
        ScrollUtils.scrollTo({
            target: VanillaUtils.getOffsetRect(this._elWrapper).top + this._elWrapper.offsetHeight, 
            speed:0.05,
            easing:Linear.easeNone
        });
    }

    public get elWrapper() : HTMLElement {
        return this._elWrapper;
    }

    public hide() {
        TweenMax.set(this._elWrapper, {visibility:'hidden'});
    }

    public show() {
        TweenMax.set(this._elWrapper, {visibility:'visible'});
    }

}